/**
 * FBO Service
 * Fetches the FBO list for an airport (Aviapages), cached per ICAO so opening
 * the selector repeatedly never re-hits the API for the same airport.
 */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

/**
 * React Query hook for an airport's FBOs, keyed by ICAO.
 * @param {string} icao - Airport ICAO (e.g. "KSNA")
 * @param {boolean} [enabled=true] - Gate the fetch (e.g. only when the modal opens)
 */
export function useFbos(icao, enabled = true) {
  const code = (icao || '').toUpperCase();
  return useQuery({
    queryKey: ['fbos', code],
    queryFn: () => apiClient.getFbos(code),
    enabled: !!code && enabled,
    staleTime: Infinity,   // an airport's FBO list rarely changes within a session
    cacheTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
